module.exports = __webpack_public_path__ + "img/1554211185.35ad4319.jpg";